const __inViewOff = function (event, handler) {
    let length = this.handlers[event].length;
    let b = true;
    while (--length > -1 && b) {
        if (this.handlers[event][length] === handler) {
            this.handlers[event].splice(length, 1);
            b = false;
        }
    }
};

const __inViewRemoveAllListeners = function () {
    let event;
    for (event in this.singles) {
        if (this.singles.hasOwnProperty(event))
            while (this.singles[event].length) {
                this.singles[event].pop();
            }
    }
    for (event in this.handlers) {
        if (this.handlers.hasOwnProperty(event))
            while (this.handlers[event].length) {
                this.handlers[event].pop();
            }
    }
};

module.exports = inview => {

    inview.off = __inViewOff.bind(inview);
    inview.removeAllListeners = __inViewRemoveAllListeners.bind(inview);

    return inview;
};


// WEBPACK FOOTER //
// ./js/viscom/viscomjs/utils/InViewOffMixin.js